<template>
<div class="contentBox denamdStatisticsPage">
    <div class="pageTitle">
        <el-steps :active="3" simple finish-status="wait" style="padding-left: 0">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/onDemand/edit')"></el-step>
            <el-step title="文件管理" icon="el-icon-files" @click.native="jumpNavPage('/onDemand/file')"></el-step>
            <el-step title="分享" icon="el-icon-share" @click.native="jumpNavPage('/onDemand/share')"></el-step>
            <el-step title="访问统计" icon="el-icon-data-analysis"></el-step>
        </el-steps>
    </div>
    <div class="overviewBox">
        <div class="videoInfo">
            <i class="videoBtn"></i>
            <div class="videoListImgIcon">
                <img :src="poster" alt=""  style="width:100%" />
            </div>
            <div class="videoListText">
                <a herf="javascript:;" class="liveName">
                  {{ title }}
                </a>
                <div class="liveTime">创建时间：{{ createTime }}</div>
            </div>
        </div>
        <div class="balance">
            <div class="item">
                <span class="title">播放量</span>
                <div class="number" >{{ playAmount }} <span v-if="playAmountUnit">万</span></div>
            </div>
            <div class="item">
                <span class="title">流量</span>
                <div class="number">{{ totalFlow }} <span>{{ totalFlowUnit }}</span></div>
            </div>
            <div class="item">
                <span class="title">存储</span>
                <div class="number">{{ space }} <span>{{ spaceUnit }}</span></div>
            </div>
            <div class="item last">
                <span class="title">转码时长</span>
                <div class="number">{{ transDuration }} <span v-if="transDurationUnit">H</span></div>
            </div>
        </div>
    </div>
    <div class="statistPrompt" v-if="statistPromptFlag">

        <img src="../../assets/rulesTips.svg" class="SPIcon" alt="" />
        <div class="SPText">
            &nbsp;以下统计数据支持90天内在线查询统计，90天后数据将被清除。如需保存数据，请使用图表的导出功能将数据导出本地保存。
        </div>
        <img src="../../assets/nodeCloseBtn.svg" class="SPCloseBtn" @click="deleteStatistPrompt()" />
    </div>

<!--    <div style="margin-top: 12px">
      <el-select v-model="optionValue" placeholder="请选择">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>


      <el-date-picker
          v-model="dateValue"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="margin-left: 6px">
      </el-date-picker>

      <el-button type="primary" @click="dateSearch" icon="el-icon-search" style="margin-left: 6px">查询</el-button>

    </div>-->

    <el-card shadow="never" style="margin-right: 10px">
        <div slot="header" class="clearfix">
            <span>统计时段</span>
        </div>
        <el-row :gutter="12">
            <el-col :span="14">
                <el-radio-group v-model="statRange">
                    <el-radio-button v-for="item in PRESET_RANGE" :label="item" :key="item"></el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="10" style="border-left: 1px solid #e8e8e8" v-if="statRange === '自定义'">
                <el-date-picker
                    v-model="customRange"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束事件"
                    range-separator="至">
                </el-date-picker>
            </el-col>
        </el-row>
    </el-card>



    <div class="advanceds">
        <div class="title">
            <span>访问次数</span>
            <div class="buttonBox">
<!--                <button class="report">报告</button>
                <button class="download">下载</button>-->
            </div>
        </div>
        <div ref="pvChart" :style="{ width: '1210px', height: '370px' }" class="linechart"></div>
    </div>

    <div class="advanceds">
        <div class="title">
            <span>绝对用户数</span>
            <div class="buttonBox">
            </div>
        </div>
      <div ref="uvChart" :style="{ width: '1210px', height: '370px' }" class="linechart"></div>
    </div>

    <div class="advanceds">
      <div class="title">
        <span>流量</span>
        <div class="buttonBox">
        </div>
      </div>
      <div ref="bandwidthChart" :style="{ width: '1210px', height: '370px' }" class="linechart"></div>
    </div>

    <div class="advanceds">
        <div class="title">
            <span>用户分布</span>
        </div>
        <div ref="regionCharts" :style="{ width: '1210px', height: '370px', paddingLeft: '14px' }" class="linechart"></div>
    </div>
</div>
</template>

<script>
    import common from '../../common.vue';

    let Echarts = require("echarts/lib/echarts"); //基础实例 注意不要使用import
    require("echarts/lib/chart/lines");
    require("echarts/lib/chart/line");
    require("echarts/lib/chart/map");
    require("../../untils/china.js");
    const GET_VOD_STAT_URL = common._BASE_ + 'vod/statData';
    const GET_STAT_INFO_URL = common._BASE_  + 'vod/statInfo';

    //import $ from 'jquery'
    import moment from 'moment'

    export default {
        name: "FemandStatistics",
        data() {
            return {
                // 预定义的统计时间段
                PRESET_RANGE : ['今天','昨天','一天','本周','一周','本月','30天','3个月','自定义'],
                // 显示的监控还是统计
                activeTab: "STAT",
                // 统计时间段
                statRange: '今天',
                // 自定义时间段
                customRange: [],
                statistPromptFlag: true,
                CUSTOM_TYPE: 23,
                DATE_SPLITTER: '至',
                vodId: -1,
                pvStatData: '',
                uvStatData: '',
                bandwidthStatData: '',
                mapData: '',
                title: '',
                poster: '',
                createTime: '',
                // 累计流量
                totalFlow: '',
                totalFlowUnit: '',
                // 累计大小
                space: '',
                spaceUnit: '',
                //  时长
                transDuration: '',
                transDurationUnit: false,
                //播放量
                playAmount: '',
                playAmountUnit: true,
                //时间
                options: [{
                    value: '1',
                    label: '今天'
                }, {
                    value: '2',
                    label: '昨天'
                }, {
                    value: '3',
                    label: '一天'
                }, {
                    value: '4',
                    label: '本周'
                }, {
                    value: '5',
                    label: '一周'
                }, {
                    value: '6',
                    label: '本月'
                }, {
                    value: '7',
                    label: '30天'
                }, {
                    value: '8',
                    label: '3个月'
                }],
                optionValue: '1',
                dateValue: '',
                mapMax: 0,
            };
        },
        methods: {
            /**
             * 请求频道统计数据
             */
            queryData(type) {
                let _this = this, from = null, to = null;
                _this.vodId = _this.$route.params.id || _this.$route.query.id;

                if (parseInt(type) === _this.CUSTOM_TYPE) {
                    //var ss = $('#stat-range').val().split(_this.DATE_SPLITTER);
                    //let ss = _this.dateValue;
                    //if (ss) {
                    from = moment(this.customRange[0]).format('YYYY-MM-DD HH:mm:ss');
                    to = moment(this.customRange[1]).format('YYYY-MM-DD HH:mm:ss');
                    //}

                }
                let data = Object.assign({vodId: _this.vodId, type: type});
                if (from && to) {
                    data = Object.assign({
                        vodId: _this.vodId,
                        type: type,
                        from: _this.formatDate(from),
                        to: _this.formatDate(to)
                    });
                    console.log(data);
                }

                _this.$axios.post(GET_VOD_STAT_URL, this.$qs.stringify(data)).then(function (res) {
                    console.log(res);
                    _this.renderCharts(res.data.stat);
                });

            },
            /**
             * 选定了自定义时间
             */
            customRangeChanged(){
                this.acquireStatData(this.CUSTOM_TYPE,
                    moment(this.customRange[0]).format('YYYY-MM-DD HH:mm:ss'),
                    moment(this.customRange[1]).format('YYYY-MM-DD HH:mm:ss'));
            },
            /**
             * 更改统计时段
             */
            statRangeChanged(){
                if(this.statRange !== '自定义'){
                    let type = this.PRESET_RANGE.indexOf(this.statRange);
                    if(type < 0){ return; }
                    // 请求数据
                    this.queryData(type + 1);
                }
            },
            getVodInfo: function () {
                var _this = this;
                let data = Object.assign({vodId: _this.vodId});
                _this.$axios.post(GET_STAT_INFO_URL, this.$qs.stringify(data)).then(function (res) {
                    console.log(res);
                    let result = res.data.stat;
                    _this.createTime = result.createTime;
                    _this.poster = result.poster;
                    _this.title = result.title;


                    /*space: 224827508

                    totalFlow: 25181455
                    transDuration: 1864
                    vodId: 1*/

                    _this.playAmount = result.playAmount;
                    if (result.playAmount < 1000) {
                        _this.playAmountUnit = false;
                    } else {
                        _this.playAmount = _this.playAmount / 10000
                    }

                    let flows = _this.formatSize(result.totalFlow);
                    _this.totalFlow = flows[0];
                    _this.totalFlowUnit = flows[1];

                    let spaces = _this.formatSize(result.space);
                    _this.space = spaces[0];
                    _this.spaceUnit = spaces[1];

                    _this.transDuration = _this.seconds2duration(result.transDuration);
                });
            },
            renderCharts(statData) {
                if (!statData) {
                    return;
                }
                // 整理数据
                let _this = this, item;

                _this.pvStatData = [];
                _this.uvStatData = [];
                _this.bandwidthStatData = [];
                _this.mapData = [];
                let stampData = statData.stampDataList || [];
                for (var i = 0; i < stampData.length; i++) {
                    item = stampData[i];
                    _this.pvStatData.push([item.stamp * 1000, item.pv]);
                    _this.uvStatData.push([item.stamp * 1000, item.uv]);
                    _this.bandwidthStatData.push([item.stamp * 1000, parseInt(item.flow) / 1000 / 1000]);
                }
                var mapDataList = statData.mapDataList || [], m;
                for (i = 0; i < mapDataList.length; i++) {
                    // 格式化为{name:'上海市', value:[lat,long,value]}的格式
                    m = mapDataList[i];
                    _this.mapData.push({
                        name: m.city.replace('市', '').replace('省', ''),
                        value: [].concat(m.longitude, m.latitude, m.userCount)
                    })
                }
                // 按人数多少排序
                _this.mapData.sort(function (a, b) {
                    return b.value[2] - a.value[2];
                });
                if (_this.mapData.length > 0) {
                    var max = _this.mapData[0].value[2];
                    if (max > 0) {
                        _this.heatPointScale = _this.MAX_POINT_SIZE / max;
                    }
                    _this.mapMax = max;
                }
                _this.initUserChart();
                _this.initBandwidthChart();
                console.log(_this.mapData);
                _this.drawregionCharts();
                //_this.initMapChart();
            },
            /**
             * 初始化用户图表
             */
            initUserChart() {

                var _this = this,
                    pvOption = {
                        tooltip: {
                            trigger: 'axis'
                        },
                        toolbox: {
                            show: true,
                            feature: {
                                dataView: {readOnly: true},
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'time'
                        },
                        yAxis: {
                            type: 'value',
                            boundaryGap: [0, '10%']
                        },
                        series: [{
                            name: '访问次数',
                            type: 'line',
                            data: _this.pvStatData,
                            showSymbol: false,
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        color: '#8cd5c2'
                                    }
                                }
                            },
                            markPoint: {
                                data: [
                                    {type: 'max', name: '最大值'}
                                ]
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            }
                        }]
                    },
                    uvOption = {
                        tooltip: {
                            trigger: 'axis'
                        },
                        toolbox: {
                            show: true,
                            feature: {
                                dataView: {readOnly: true},
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'time'
                        },
                        yAxis: {
                            type: 'value',
                            boundaryGap: [0, '10%']
                        },
                        series: [{
                            name: '绝对用户数',
                            type: 'line',
                            data: _this.uvStatData,
                            showSymbol: false,
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        color: '#ee6666'
                                    }
                                }
                            },
                            markPoint: {
                                data: [
                                    {type: 'max', name: '最大值'}
                                ]
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            }
                        }]
                    };
                _this.pvLinechart = Echarts.init(this.$refs.pvChart);
                _this.uvLinechart = Echarts.init(this.$refs.uvChart);
                //_this.pvLineCharts = echarts.init(document.getElementById('chart-pv'));
                pvOption && _this.pvLinechart.setOption(pvOption);
                // 绝对用户数
                // _this.uvLineCharts = echarts.init(document.getElementById('chart-uv'));
                uvOption && _this.uvLinechart.setOption(uvOption);
            },
            /**
             * 初始化流量图表
             */
            initBandwidthChart() {
                let _this = this, option = {
                    tooltip: {
                        trigger: 'axis',
                        position: function (pt) {
                            return [pt[0], '10%'];
                        },
                        formatter: function (params) {
                            var param = params[0], time = new Date(param.value[0]), flow = param.value[1].toFixed(2);
                            return _this.formatTooltipTime(time) + ' 带宽： ' + flow + "M";
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            dataView: {readOnly: true},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'time'
                    },
                    yAxis: {
                        type: 'value',
                        name: '带宽（单位M）',
                        boundaryGap: [0, '10%']
                    },
                    series: [{
                        title: '带宽',
                        type: 'line',
                        data: _this.bandwidthStatData,
                        lineStyle: {
                            width: 0
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0, 221, 255)'
                            }, {
                                offset: 1,
                                color: 'rgba(77, 119, 255)'
                            }])
                        }
                    }]
                };
                _this.bandwidthAreaCharts = Echarts.init(this.$refs.bandwidthChart);
                //_this.bandwidthAreaCharts = echarts.init(document.getElementById('chart-bandwidth'));
                option && this.bandwidthAreaCharts.setOption(option);
            },
            drawregionCharts() {
                let _this = this;
                this.mapchart = Echarts.init(this.$refs.regionCharts);
                let dataList = this.mapData;
                let option = {
                    tooltip: {
                        trigger: "item",
                        formatter: function (params) {
                            return params.name; //自行定义formatter格式
                        },
                    },
                    visualMap: {
                        min: 0,
                        max: _this.mapMax,
                        left: "left",
                        top: "bottom",
                        text: ["高", "低"], //取值范围的文字
                        inRange: {
                            color: ["#e0ffff", "#006edd"], //取值范围的颜色
                        },
                        show: true, //图注
                    },
                    geo: {
                        map: "china",
                        roam: false, //不开启缩放和平移
                        zoom: 1.23, //视角缩放比例
                        label: {
                            normal: {
                                show: true,
                                fontSize: "10",
                                color: "rgba(0,0,0,0.7)",
                            },
                            emphasis: {
                                textStyle: {
                                    color: "#fff",
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                borderColor: "rgba(0, 0, 0, 0.2)",
                            },
                            emphasis: {
                                areaColor: "#F3B329", //鼠标选择区域颜色
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 20,
                                borderWidth: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                    series: [{
                        name: "信息量",
                        type: "map",
                        geoIndex: 0,
                        data: dataList,
                    },],
                };
                this.mapchart.setOption(option);
            },
            deleteStatistPrompt() {
                this.statistPromptFlag = false;
            },
            dateSearch() {
                let _this = this;

                let ss = _this.dateValue, from = null, to = null;
                if (ss) {
                    from = ss[0];
                    to = ss [1];
                }
                if (!from || !to) {
                    _this.open('提示', '请选择时间范围');
                }
                this.queryData(_this.CUSTOM_TYPE);
            },
            /**
             * 格式化图标提示时间
             * @param time
             */
            formatTooltipTime(time) {
                return this.addZero(time.getMonth() + 1) + '-' +
                    this.addZero(time.getDay() + 1) + ' ' +
                    this.addZero(time.getHours()) + ':' +
                    this.addZero(time.getMinutes())
            },
            /**
             * 不满两位补零
             * @param v
             */
            addZero(v) {
                return parseInt(v) < 10 ? '0' + v : v;
            },
            formatSize(size) {
                var isMinus = false;
                if (!size) {
                    size = 0;
                }
                if (isNaN(size) && /\D/.test(size)) {
                    return 'N/A';
                }
                if (size < 0) {
                    isMinus = true;
                    size = Math.abs(size);
                }

                function round(num, precision) {
                    return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
                }

                var boundary = Math.pow(1024, 4);

                // TB
                if (size > boundary) {
                    return [round(size / boundary, 1), 'T'];
                }

                // GB
                if (size > (boundary /= 1024)) {
                    return [round(size / boundary, 1), 'G'];
                }

                // MB
                if (size > (boundary /= 1024)) {
                    return [round(size / boundary, 1), 'M'];
                }

                // KB
                if (size > 1024) {
                    return [Math.round(size / 1024), 'K'];
                }
                if (isMinus) {
                    return ["-" + size, 'B'];
                }
                return [size, 'B'];
            },
            seconds2duration(seconds) {
                var prefix = seconds >= 0 ? "" : "-";
                seconds = Math.abs(seconds);
                var hours = Math.floor(seconds / 3600);
                var minutes = Math.floor((seconds - (hours * 3600)) / 60);
                seconds = seconds - (hours * 3600) - (minutes * 60);
                var time = "";

                if (hours != 0) {
                    time = hours + ":";
                }
                minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
                time += minutes + ":";
                time += (seconds < 10) ? "0" + seconds : String(seconds);
                return prefix + time;
            },
            formatDate(time) {
                console.log(time)
                console.log(moment(time).format("YYYY-MM-DD HH:mm:ss"))
                return moment(time).format("YYYY-MM-DD HH:mm:ss");
            },
            //消息
            open(title, content) {
                this.$alert(content, title, {
                    confirmButtonText: '确定',
                });
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path + "/" + this.vodId
                });
            }

        },
        mounted() {
            this.queryData(1);
            this.getVodInfo();
            //this.linesChart();
            //this.drawregionCharts();
        },
        watch: {
            'optionValue': function (value) {
                console.log('opValue == ' + value);
                this.queryData(value);
            },
            customRange(){
                this.queryData(this.CUSTOM_TYPE);
                //this.customRangeChanged();
            },
            statRange(){
                this.statRangeChanged();
            },
        },
    };
</script> 

<style lang="less">
.denamdStatisticsPage {
    .overviewBox {
        width: 1210px;
        height: 139px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        margin-bottom: 17px;
        padding: 16px 24px;
        display: flex;

        .videoInfo {
            width: 500px;
            display: flex;
            // cursor: pointer;
            position: relative;

            .videoBtn {
                width: 32px;
                height: 32px;
                background: url("../../assets/playIcon.9baf1030.svg") no-repeat center center;
                background-size: 100% auto;
                border-radius: 50%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 46px;
                margin: auto 0;
                z-index: 2;
                transition: all 0.2s ease-out;
                opacity: 0;
                transform: scale(1.2);
                cursor: pointer;
            }

            .videoListImgIcon {
                width: 176px;
                height: 100px;
                overflow: hidden;
                margin-right: 20px;
                cursor: pointer;

                img {
                    transition: all 0.4s;
                    -webkit-transition: all 0.4s;
                }
            }

            .liveName {
                height: 56px;
                font-size: 16px;
                line-height: 26px;
                color: #221816;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-bottom: 28px;
                cursor: pointer;
            }

            .liveTime {
                font-size: 12px;
                color: #a2a9ab;
            }
        }

        .videoInfo:hover {
            .videoBtn {
                opacity: 1;
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -ms-transform: scale(1);
                -o-transform: scale(1);
                transform: scale(1);
            }

            .videoListImgIcon {
                img {
                    transform: scale(1.06);
                    -webkit-transform: scale(1.06);
                }
            }

            .liveName {
                color: #306ff6;
            }
        }

        .balance {
            width: 700px;
            display: flex;

            .item {
                width: 224px;
                padding-left: 39px;
                padding-top: 20px;
                border-left: 1px solid #e8e8e8;
            }

            .last {
                margin-right: 0;
            }

            .middle {
                margin-right: 174px;
            }

            .title {
                font-size: 14px;
                font-weight: 400;
                color: #c1c5c5;
            }

            .number {
                font-size: 34px;
                font-weight: bold;
                color: #221816;
                margin-top: 6px;
                font-family: DIN Alternate;

                span {
                    font-size: 14px;
                    color: #221816;
                    margin-left: 12px;
                }
            }
        }
    }

    .tabsBox {
        border-bottom: solid 1px #306ff6;

        span {
            display: inline-block;
            width: 140px;
            height: 40px;
            border-radius: 6px 6px 0 0;
            background: #ffffff;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
            margin-right: 15px;
            border: solid 1px #e8e8e8;
            border-bottom: none;
            color: #221816;
            cursor: pointer;
        }

        span.active {
            background: #306ff6;
            color: #fff;
            border: solid 1px #306ff6;
        }
    }

    .statistPrompt {
        width: 1210px;
        height: 65px;
        background: #fffdef;
        border-radius: 4px;
        margin-top: 16px;
        padding: 0 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .SPText {
            width: 1100px;
        }

        .SPCloseBtn {
            cursor: pointer;
        }
    }

    .advanceds {
        width: 1210px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        margin: 15px 0;

        .tipsBox {
            height: 44px;
            margin: 0 25px;
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 26px;
            color: #7e868c;
            border-bottom: 1px dashed #e8e8e8;

            img {
                margin-right: 6px;
            }
        }

        .title {
            height: 44px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 21px;
            font-size: 16px;
            font-weight: bold;
            color: #221816;
            position: relative;

            span::before {
                content: "";
                display: inline-block;
                width: 4px;
                height: 12px;
                background: #306ff6;
                border-radius: 3px;
                margin-right: 6px;
            }

            .buttonBox {
                position: absolute;
                right: 16px;

                button {
                    width: 80px;
                    height: 25px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: 400;
                    margin-left: 9px;
                }

                .download {
                    background: #076eff;
                    color: #fff;
                }

                .download:hover {
                    background: #4aa3f8;
                }

                .report {
                    background: #ffffff;
                    border: 1px solid #c1c5c5;
                    color: #221816;
                }

                .report:hover {
                    background: #076eff;
                    color: #fff;
                    border: none;
                }
            }
        }

        .linechart {
            padding: 23px 0;
        }
    }
}
</style>